import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const VacuumCleaner = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M26 19.003V17C26 15.346 24.654 14 23 14H22V12C22 7.589 18.411 4 14 4C9.589 4 6 7.589 6 12V20.172C4.836 20.585 4 21.696 4 23V25C4 26.654 5.346 28 7 28C8.654 28 10 26.654 10 25V23C10 21.696 9.164 20.585 8 20.172V12C8 8.691 10.692 6 14 6C17.308 6 20 8.691 20 12V14H19.5C15.364 14 12 17.364 12 21.5V23C12 24.654 13.346 26 15 26H19.003C19.916 27.214 21.368 28 23 28C25.757 28 28 25.757 28 23C28 21.368 27.214 19.916 26 19.003ZM8 25C8 25.551 7.551 26 7 26C6.449 26 6 25.551 6 25V23C6 22.449 6.449 22 7 22C7.551 22 8 22.449 8 23V25ZM18 23C18 23.342 18.035 23.677 18.101 24H15C14.449 24 14 23.551 14 23V21.5C14 18.467 16.467 16 19.5 16H23C23.551 16 24 16.449 24 17V18.101C23.677 18.035 23.342 18 23 18C20.243 18 18 20.243 18 23ZM23 26C21.346 26 20 24.654 20 23C20 21.346 21.346 20 23 20C24.654 20 26 21.346 26 23C26 24.654 24.654 26 23 26Z" />
	</svg>
);

export default VacuumCleaner;
